//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LanguagesButtons',
  methods: {
    updateLocal (local) {
      this.$store.commit('EDIT_LOCAL', local)
    }
  }
}
